import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxEchartsDirective } from 'ngx-echarts';
import type { EChartsOption } from 'echarts';

import { MesCusto } from '../../../shared/model/relatorio-custo.models';

@Component({
  selector: 'app-chart-custos-vertical',
  standalone: true,
  imports: [CommonModule, NgxEchartsDirective],
  templateUrl: './chart-custos-vertical.component.html',
  styleUrls: ['./chart-custos-vertical.component.css'],
})
export class ChartCustosVerticalComponent implements OnChanges {
  @Input({ required: true }) meses!: MesCusto[];
  @Input() metaToggle = false;

  options: EChartsOption = {};

  ngOnChanges(): void {
    const labels = (this.meses ?? []).map(m => m.nomeCurto);
    const totals = (this.meses ?? []).map(m => m.total ?? 0);

    const marketing = (this.meses ?? []).map(m => (m.porCategoriaMeta?.MARKETING ?? 0));
    const utility = (this.meses ?? []).map(m => (m.porCategoriaMeta?.UTILITY ?? 0));
    const auth = (this.meses ?? []).map(m => (m.porCategoriaMeta?.AUTHENTICATION ?? 0));

    const formatUSD = (value: number) =>
      value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

    const base: EChartsOption = {
      grid: { left: 10, right: 10, top: 40, bottom: 12, containLabel: false },
      tooltip: { show: false },

      xAxis: {
        type: 'category',
        data: labels,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { color: '#2B2B2B', fontWeight: 700 },
      },

      yAxis: {
        type: 'value',
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitLine: { show: false },
      },

      legend: { show: false },
    };

    if (!this.metaToggle) {
      this.options = {
        ...base,
        series: [
          {
            name: 'Total',
            type: 'bar',
            barWidth: '55%',
            data: totals,
            itemStyle: { color: 'rgba(153, 61, 245, 0.2)' },
            label: {
              show: true,
              position: 'top',
              rotate: 90,       
              distance: 40,      
              color: '#2B2B2B',
              fontFamily: 'Segoe UI',
              fontWeight: 600,
              formatter: (p: any) => formatUSD(Number(p.value ?? 0)),
            },
          },
        ],
      };
      return;
    }

    this.options = {
      ...base,
      series: [
        {
          name: 'Marketing',
          type: 'bar',
          stack: 'total',
          barWidth: '55%',
          data: marketing,
          itemStyle: { color: '#6213B6' },
          label: { show: false },
        },
        {
          name: 'Utilidade',
          type: 'bar',
          stack: 'total',
          data: utility,
          itemStyle: { color: '#09537D' },
          label: { show: false },
        },
        {
          name: 'Autentificação',
          type: 'bar',
          stack: 'total',
          data: auth,
          itemStyle: { color: '#430F7B' },

          label: {
            show: true,
            position: 'top',
            rotate: 90,       
            distance: 40,     
            color: '#2B2B2B',
            fontFamily: 'Segoe UI',
            fontWeight: 600,
            formatter: (p: any) => {
              const idx = p?.dataIndex ?? 0;
              const total =
                (marketing[idx] ?? 0) +
                (utility[idx] ?? 0) +
                (auth[idx] ?? 0);

              return formatUSD(total);
            },
          },
        },
      ],
    };
  }
}
